<template>
  <div>
      <el-row>
        <el-form-item :error="error">
          <!-- <el-col :xs="12" :sm="24" :md="24" :lg="24" :xl="24"> -->
            <el-input-number
              :disabled="isDisabled"
              size="mini"
              :value="qty"
              :controls="false"
              @focus="handleFocus"
              @blur="handleBlur"
              @keyup.native="changeQuantity($event.target.value)">
            </el-input-number>
          <!-- </el-col> -->
          <!-- <el-col :xs="12" :sm="24" :md="24" :lg="24" :xl="24" v-if="showUnitControl"> -->
            <el-select v-model="unit" @change="changeUnit" :disabled="disabled || product_unit == 2" style="width:100px;" size="mini" class="ml-10">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          <!-- </el-col> -->
          <div slot="error" style="white-space:normal;line-height:23px;" ><span class="danger-text">{{error}}</span></div>
        </el-form-item>
      </el-row>
      <el-row style="text-align:center;"  v-if="showUnitControl && product_unit != null && product_unit != 2">
        <el-col>
            <span>{{unitMessage}}(s)</span>
        </el-col>
      </el-row>
  </div>
</template>
<script>
import productUtils from '@/utils/portaus-utils';
export default {
  name: 'unit-quantities',
	props: {
		qty_ordered : Number,
    qty_to_receive : Number,
    product_uvc : Number,
    product_unit : Number,
    qty_received : Number,
    default : {
      type : Number,
      default : null,
    },
    disabled : {
      type : Boolean,
      default : false
    },
    min : {
      type : Number,
      default : -Infinity
    },
    max : {
      type : Number,
      default : Infinity
    },
    showUnitControl : {
      type : Boolean,
      default : true
    },
    default_unit : {
      type : Number,
      default : 1
    }
	},
  data() {
    return {
      options : [{value:2, label: 'Unité(s)'}, {value:1,label:'Boîte(s)'}],
      unit : 1,
      qty : 0,
      error : null,
    };
  },components: {

  },
	methods: {
    handleFocus(){
      this.$emit('unitQuantitiesFocus');
    },
    handleBlur(){
      this.$emit('unitQuantitiesBlur');
    },
    validateQuantity(value){
      if (value > this.maximum){
        this.error=this.errorMaxMessage;
        return false;
      } else if (value < this.minimum) {
        this.error=this.errorMinMessage;
        return false;
      }
      this.error = null;
      return true;
    },
    changeUnit(value){
      this.validateQuantity(value);
      this.emitChange(null, value);
    },
    emitChange(value = null, newUnitValue = null){
      // console.log('Emit Change', value);
      // console.log('Emit Change newUnitValue', newUnitValue);
      let qty = value;
      if (value != null && ( _.trim(value) === '' || _.isNaN(value))) {
        // console.log('QTY = 0');
        qty = 0;
      }

      // if (value == null) qty = this.qty;

      if(this.error==null){
        if(newUnitValue != null) {
          // console.log('Change Unit');
          // console.log('QTY : ', this.qty);
          if (this.unit == 1) {

            this.$emit('change', this.qty);
          } else {
            // qty = this.qty;
            this.$emit('change', this.qty);
          }
        } else {
          if(this.unit==2){
            // console.log('1 - qty');
            // console.log('qty : ', qty);
            this.$emit('change',qty);
          }else{
            // console.log('2 - qty * this.product_uvc');
            // console.log('qty : ', qty);
            // console.log('this.product_uvc : ', this.product_uvc);
            this.$emit('change', qty * this.product_uvc)
          }
        }
      }else{
        this.$emit('change',null);
      }
    },
    changeQuantity(value){
      // console.log('Change quantity : ', value);
      this.validateQuantity(value);
      this.emitChange(parseInt(value));
      if (parseInt(value) == NaN) {
        this.qty = 0;
      } else {
        this.qty = parseInt(value);
      }
    },
    getProductUnit(unit){
      return productUtils.getFormattedUnit_i18n(unit);
    },
    init () {
      this.unit = this.default_unit;
      if(this.default!=null){
        if (this.default >= this.product_uvc) {
          if (this.unit == 2) {
            this.qty = this.default;
          } else {
            if (this.default % this.product_uvc != 0) {
              this.qty = this.default;
              this.unit = 2;
            } else {
              this.qty = Math.ceil(this.default / this.product_uvc);
            }

          }
        }
        else {
            this.qty = this.default;
            if (this.qty % this.product_uvc == 0)   this.unit = 1 ;
            else this.unit = 2 ;
        }
      }else{
        if(this.unit == 1){
          this.qty = this.unit_quantity;
        }else{
          this.qty=1;
        }
      }
    },
	},
	computed: {
    step () {
      if (this.product_unit != null && this.product_unit != 2) {
        return this.product_uvc;
      }
      return 1;
    },
    isDisabled(){
      return Math.ceil(this.qty_ordered/this.product_uvc) - Math.ceil(this.qty_received/this.product_uvc)==0 || this.disabled;
    },
    errorMaxMessage(){
        return "Quantité trop élevé (max : " + this.maximum + ' ' + this.$t('products.units.unitaries')+ ')';
    },
    errorMinMessage(){
        return "Quantité trop basse (min : " + this.minimum + ' ' + this.$t('products.units.unitaries')+ ')';
    },
    unitMessage(){

      if(this.unit==2){
        const qty = this.qty / this.product_uvc;
        if (qty == NaN) qty = 0;
        return Math.ceil(qty) + ' ' + this.$t('products.units.box');
      }else{
        return ((this.qty * this.product_uvc)|0) + ' ' + this.$t('products.units.unitary');
      }
    },
    maximum(){
      if(this.unit==2){
        return this.max;
      }else{
        return Math.floor(this.max/this.product_uvc)
      }
    },
    minimum(){
      if(this.unit==2){
        return this.min;
      }else{
        return Math.floor(this.min/this.product_uvc)
      }
    },
    calculatedQuantity () {
      if(this.unit==2){
        const qty = this.qty / this.product_uvc;
        if (qty == NaN) qty = 0;
        return Math.ceil(qty);
      }else{
        return ((this.qty * this.product_uvc)|0);
      }
    },
    calculateQuantityUVC(){
      return localStorage.CALCULATE_QUANTITY_UVC!=null&&localStorage.CALCULATE_QUANTITY_UVC==='1';
    },
    unit_quantity(){
      if(this.unit==1){
        return (Math.ceil(this.qty/this.product_uvc)|0)
      }else{
        return ((this.product_uvc)|0)
      }
    },
	},
  watch: {
    default(newDefault, oldDefault) {
       if (this.unit === 2) {
         this.qty = newDefault;
       } else {
         this.init();
       }

     }
   },
  created(){

  },
  mounted(){
    this.init();
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';





</style>
